import React from 'react';
import PropTypes from 'prop-types';
import { Marker, DefaultSVG } from '@geo/react-grabmaps-gl';
import { REQUIRED_OFFSET } from '../../../constants/marker';

const DROPOFF_LEVEL = [
  DefaultSVG.DropOff,
  DefaultSVG.DropOff1,
  DefaultSVG.DropOff2,
  DefaultSVG.DropOff3,
  DefaultSVG.DropOff4,
  DefaultSVG.DropOff5,
  DefaultSVG.DropOff6,
  DefaultSVG.DropOff7,
  DefaultSVG.DropOff8,
  DefaultSVG.DropOff9,
];

const DropOffMarker = ({ coordinates, level }) => {
  const DropOffPin =
    level > DROPOFF_LEVEL.length ? DROPOFF_LEVEL[0] : DROPOFF_LEVEL[level];

  return (
    <Marker
      coordinates={coordinates}
      offset={REQUIRED_OFFSET}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        willChange: 'transform',
      }}
    >
      <DropOffPin />
    </Marker>
  );
};

DropOffMarker.propTypes = {
  coordinates: PropTypes.arrayOf(PropTypes.number).isRequired,
  level: PropTypes.number,
};

DropOffMarker.defaultProps = {
  level: 0,
};

export default DropOffMarker;
